module.exports = __webpack_public_path__ + "static/media/sort-shapes-down-alt.1e84892a.svg";